import { alpha, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    backgroundColor: alpha(theme.custom.color.gainsboro, 0.26),
    borderRadius: theme.spacing(1),
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
    gap: theme.spacing(3),
  },
  header: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  dateText: {
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "20px",
    color: theme.custom.color.blackRussian,
  },
  infoIcon: {
    "& .MuiSvgIcon-root": {
      fontSize: 20,
      marginLeft: theme.spacing(1),
      color: theme.custom.color.blackRussian,
      display: "flex",
    },
  },
  barContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  cardContainer: {
    display: "flex",
    justifyContent: "left",
    gap: theme.spacing(5),
    flexWrap: "wrap",
  },
  dateWrapper: {
    display: "flex",
    alignItems: "center",
  },
  button: {
    width: "185px",
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(1),
      width: "20px",
      height: "20px",
    },
    flexShrink: 0,
  },
  toolTipText: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "14px",
  },
}));

export default useStyles;
